module.exports = __webpack_public_path__ + "static/img/mega.6bc1147d.svg";